import { EmailTemplateClient } from 'clients';
import { QueryKeys, UserRole } from 'enums';
import { EmailTemplate, EmailTemplateCreate } from 'types';
import { useCurrentUser } from './currentUser';
import { UseQueryBaseRetrieveOptions, UseQueryBaseSearchOptions } from './query/types';
import { useMutate } from './query/useMutate';
import { useQueryRetrieve, useQuerySearch } from './query/useQuery';

export function useSearchEmailTemplate(props?: UseQueryBaseSearchOptions<EmailTemplate>) {
  const { filter, enabled, queryOptions, sorter } = props || {};
  const { me } = useCurrentUser();

  // For Flow brokers impersonating retailers, we want to search Flow broker templates
  // else, if there is end user, we search for end user templates (for backoffice impersonating Flow broker)
  const getTemplatesUserIdFilter = () => {
    if (me?.role === UserRole.CapitolaBroker && me?.endUser?.role === UserRole.Retailer) {
      return me?.id;
    }
    return me?.endUser?.id ?? me?.id;
  };

  return useQuerySearch({
    queryKey: QueryKeys.EmailTemplates,
    clientClass: EmailTemplateClient,
    filter: { userId: getTemplatesUserIdFilter(), ...filter },
    sorter: sorter ?? ((a, b) => a.name.localeCompare(b.name)),
    enabled,
    queryOptions: {
      ...queryOptions,
    },
  });
}

export function useRetrieveEmailTemplate(props: UseQueryBaseRetrieveOptions<EmailTemplate>) {
  const { id, queryOptions, enabled } = props;
  return useQueryRetrieve({
    queryKey: QueryKeys.EmailTemplates,
    clientClass: EmailTemplateClient,
    id,
    enabled,
    queryOptions: {
      ...queryOptions,
    },
  });
}

export function useMutateEmailTemplate() {
  const { update: updateEmailTemplate, create: createEmailTemplate } = useMutate<
    EmailTemplate,
    EmailTemplate,
    EmailTemplateCreate,
    EmailTemplateClient
  >({
    queryKey: QueryKeys.EmailTemplates,
    clientClass: EmailTemplateClient,
    createOptions: { throwOnError: true },
    updateOptions: {
      throwOnError: true,
    },
  });

  return { updateEmailTemplate, createEmailTemplate };
}
